/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Backoffice API Gateway
 * OpenAPI spec version: 1.0.0
 */

/**
 * Selected paper-bill type from PSR extra data. Null when none is set.
 * @nullable
 */
export type PaperBillStateResponsePaperBillType =
  | (typeof PaperBillStateResponsePaperBillType)[keyof typeof PaperBillStateResponsePaperBillType]
  | null

export const PaperBillStateResponsePaperBillType = {
  STANDARD: "STANDARD",
  LARGE_PRINT: "LARGE_PRINT",
  BRAILLE: "BRAILLE",
} as const
